/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EmrClusterSpotProvisioningSpecification { 
    /**
     * The spot provisioning timeout period in minutes                
     */
    timeoutDurationMinutes?: number;
    /**
     * The action to take when TargetSpotCapacity has not been fulfilled when the TimeoutDurationMinutes has expired                
     */
    timeoutAction?: string;
    /**
     * The defined duration for Spot instances (also known as Spot blocks) in minutes                
     */
    blockDurationMinutes?: number;
}
